/* Tudo que fala com as tabelas casos e anexos. */
import { sb } from "../supabase.js";
import { S } from "../estado.js";
import { ETAPAS } from "../dados/etapas.js";
import { live, toast } from "../util.js";
import { desenhar } from "../render.js";

/* Carrega os casos com os anexos embutidos. O RLS já filtra por permissão. */
export async function carregar(){
  live(false,"carregando");
  const {data,error}=await sb.from("casos")
    /* anexos(*) em vez da lista de colunas: assim coluna nova no banco nao
       derruba a consulta enquanto a migracao ainda nao rodou. */
    .select("*, anexos(*)")
    .order("entrada",{ascending:true});
  if(error){ live(false,"sem conexão"); toast("Não deu para carregar: "+error.message); return; }
  /* Reserva do portal que ainda nao virou arquivo fica de fora: ela existe
     para a policy do Storage conferir o caminho, e nao e documento nenhum.
     confirmado indefinido e banco sem a migracao 007, e ai tudo vale. */
  S.casos=(data||[]).map(c=>({...c,anexos:(c.anexos||[]).filter(a=>a.confirmado!==false)}));
  live(true,"ao vivo"); desenhar();
}

/* Assina as mudanças em tempo real e recarrega com um respiro de 400ms. */
export function escutar(){
  let t=null;
  const agendar=()=>{ clearTimeout(t); t=setTimeout(carregar,400); };
  sb.channel("painel")
    .on("postgres_changes",{event:"*",schema:"public",table:"casos"},agendar)
    .on("postgres_changes",{event:"*",schema:"public",table:"anexos"},agendar)
    .subscribe(st=>{ if(st==="SUBSCRIBED") live(true,"ao vivo"); });
}

/* Move um caso de coluna. Aplica na tela primeiro e desfaz se o banco recusar. */
export async function mover(id,passo){
  const c=S.casos.find(x=>x.id===id); if(!c) return;
  const i=ETAPAS.findIndex(e=>e.id===c.etapa), j=i+passo;
  if(j<0||j>=ETAPAS.length) return;
  const antes=c.etapa; c.etapa=ETAPAS[j].id; desenhar();
  const {error}=await sb.from("casos").update({etapa:ETAPAS[j].id}).eq("id",id);
  if(error){ c.etapa=antes; desenhar(); toast("Não deu para mover: "+error.message); }
  else toast(`${c.cliente} → ${ETAPAS[j].nome}`);
}

export async function mudarEtapa(id,etapa){
  return sb.from("casos").update({etapa}).eq("id",id);
}
export async function inserirCaso(dados){
  return sb.from("casos").insert(dados).select("id").single();
}
export async function atualizarCaso(id,dados){
  return sb.from("casos").update(dados).eq("id",id);
}
export async function excluirCaso(id){
  return sb.from("casos").delete().eq("id",id);
}
